import { render, staticRenderFns } from "./SearchExpenses.vue?vue&type=template&id=ceb11850&scoped=true"
import script from "./SearchExpenses.vue?vue&type=script&lang=js"
export * from "./SearchExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb11850",
  null
  
)

export default component.exports